import {
  DAYS_OF_WEEK,
  PeakCalloutCell,
  ResolutionSpeedCell,
  TIMEFRAMES,
} from 'pages/ReportsPage/components/AnalyticsDashboards/calloutMappers';

export const OVERTIME_HOURS_BY_POSITION_STUB = [
  { position: 'Resident Care Partner (PSW)', overtimeHours: 450 },
  { position: 'Wellness Nurse', overtimeHours: 200 },
  { position: 'Medication Care Partner', overtimeHours: 180 },
  { position: 'Server', overtimeHours: 120 },
  { position: 'Housekeeper', overtimeHours: 95 },
  { position: 'Dishwasher', overtimeHours: 68 },
  { position: 'Concierge', overtimeHours: 55 },
  { position: 'Culinary Floor Attendant', overtimeHours: 45 },
  { position: 'Cook', overtimeHours: 38 },
  { position: 'Life Enrichment Assistant', overtimeHours: 28 },
  { position: 'Companion Service Partner', overtimeHours: 15 },
  { position: 'Assistant Cook', overtimeHours: 10 },
  { position: 'Night Building Attendant', overtimeHours: 8 },
  { position: 'Sous Chef', overtimeHours: 4 },
  { position: 'Maintenance Assistant', overtimeHours: 2 },
  { position: 'RCP Student', overtimeHours: 0 },
];

export const OVERTIME_BY_TEAM_MEMBER_TYPE_STUB = [
  { type: 'Full Time', overtimeHours: 549, percentage: 41.65 },
  { type: 'Part Time', overtimeHours: 401, percentage: 30.42 },
  { type: 'Casual', overtimeHours: 368.25, percentage: 27.93 },
  { type: 'Flex', overtimeHours: 0, percentage: 0 },
];

export const OVERTIME_TREND_STUB = [
  { date: '2026-05-11', overtimeHours: 50 },
  { date: '2026-05-12', overtimeHours: 48 },
  { date: '2026-05-13', overtimeHours: 55 },
  { date: '2026-05-14', overtimeHours: 62 },
  { date: '2026-05-15', overtimeHours: 90 },
  { date: '2026-05-16', overtimeHours: 96 },
  { date: '2026-05-17', overtimeHours: 72 },
];

export const OVERTIME_INDIVIDUALS_STUB = [
  {
    teamMemberId: '59bb877d',
    teamMemberName: 'Kgalalelo Msipha',
    teamMemberType: 'Casual',
    overtimeHours: 69,
  },
  {
    teamMemberId: '027e8b29',
    teamMemberName: 'Olanike Bamimore',
    teamMemberType: 'Part Time',
    overtimeHours: 69,
  },
  {
    teamMemberId: '9f8c2e56',
    teamMemberName: 'Rose Mary Jacob',
    teamMemberType: 'Casual',
    overtimeHours: 35,
  },
  {
    teamMemberId: '52cdac59',
    teamMemberName: 'Janet Davis',
    teamMemberType: 'Part Time',
    overtimeHours: 34.5,
  },
  {
    teamMemberId: '89116e91',
    teamMemberName: 'Claudine Irumva',
    teamMemberType: 'Full Time',
    overtimeHours: 33,
  },
];

const PEAK_CALLOUT_MATRIX = [
  [258, 256, 206, 216, 215, 221, 269],
  [118, 100, 76, 80, 86, 99, 99],
  [135, 145, 98, 130, 106, 122, 149],
];

const RESOLUTION_SPEED_MATRIX = [
  [296.76, 322.05, 266.12, 307.58, 299.65, 306.74, 281.62],
  [298.89, 252.09, 256.89, 283.64, 286.14, 284.1, 301.61],
  [344.83, 395.45, 373.32, 340.03, 373.9, 377.62, 359.82],
];

export const PEAK_CALLOUT_CELLS_STUB: PeakCalloutCell[] = TIMEFRAMES.flatMap(
  (timeframe, timeframeIndex) =>
    DAYS_OF_WEEK.map((dayOfWeek, dayIndex) => ({
      timeframe,
      dayOfWeek,
      shiftCount: PEAK_CALLOUT_MATRIX[timeframeIndex][dayIndex],
    })),
);

export const RESOLUTION_SPEED_CELLS_STUB: ResolutionSpeedCell[] = TIMEFRAMES.flatMap(
  (timeframe, timeframeIndex) =>
    DAYS_OF_WEEK.map((dayOfWeek, dayIndex) => ({
      timeframe,
      dayOfWeek,
      avgHours: RESOLUTION_SPEED_MATRIX[timeframeIndex][dayIndex],
    })),
);
